import { InquiryActionTypes } from './type';
import format from 'src/utils/format';

/****** action creator ******/

/****** 获取问诊单详情 ******/
export const fetch_inquiry_detail = (options: any, onSuccess?: any) => ({
  type: InquiryActionTypes.FETCH_INQUIRY_DETAIL,
  options,
  onSuccess,
});

/****** 清除问诊单详情 ******/
export const clear_inquiry_detail = () => ({
  type: InquiryActionTypes.CLEAR_INQUIRY_DETAIL,
});

/****** 获取问诊单列表 ******/
export const fetch_inquiry_list = (options?: any, onSuccess?: any) => ({
  type: InquiryActionTypes.FETCH_INQUIRY_LIST,
  options,
  onSuccess,
});

/****** 取消问诊单 ******/
export const cancel_inquiry = (inquiryId) => ({
  type: InquiryActionTypes.CANCEL_INQUIRY,
  inquiryId,
});

/****** 编辑问诊单 ******/
export const edit_inquiry = (key: string, value: any, payload?: any) => ({
  type: InquiryActionTypes.EDIT_INQUIRY,
  key,
  value,
  payload,
});

export const edit_inquiry_addFile = (data={}) => ({
  type: InquiryActionTypes.UPLOAD_FILE_SUCCESS,
  data
});

/****** 清空问诊单 ******/
export const clear_inquiry = (data = {}) => ({
  type: InquiryActionTypes.CLEAR_INQUIRY,
  data: { ...data, uid: format.guid() },
});

/****** 获取用户评价tag列表 ******/
export const fetch_evaluate_tags = (onSuccess?: any) => ({
  type: InquiryActionTypes.FETCH_EVALUATE_TAGS,
  onSuccess,
});

/****** 获取用户评价tag列表 ump ******/
export const fetch_ump_evaluate_tags = (onSuccess?: any) => ({
  type: InquiryActionTypes.FETCH_UMP_EVALUATE_TAGS,
  onSuccess,
});

/****** 提交评价 ******/
export const submit_evaluate = (data, onSuccess) => ({
  type: InquiryActionTypes.SUBMIT_EVALUATE,
  data,
  onSuccess,
});

/****** 根据问诊单获取医生评价 ******/
export const fetch_evaluate_by_inquiry = (inquiryId) => ({
  type: InquiryActionTypes.FETCH_EVALUATE_BY_INQUIRY,
  inquiryId,
});

/****** 提交问诊单 ******/
export const submit_inquiry = (onSuccess?: any, data?: any) => ({
  type: InquiryActionTypes.SUBMIT_INQUIRY,
  onSuccess,
  data,
});

/****** 试算问诊单价格 ******/
export const fetch_inquiry_price = (data, onSuccess?: any) => ({
  type: InquiryActionTypes.FETCH_INQUIRY_PRICE,
  data,
  onSuccess,
});

/****** 获取问诊单编号 ******/
export const fetch_inquiry_no = (payload?: any) => ({
  type: InquiryActionTypes.FETCH_INQUIRY_NO,
  payload,
});

/****** 上传附件 ******/
export const upload_file = (formData) => ({ type: InquiryActionTypes.UPLOAD_FILE, formData });

/****** 删除附件 ******/
export const delete_file = (id) => ({ type: InquiryActionTypes.DELETE_FILE, id });

/****** 清空评价详情 ******/
export const clear_evaluate = () => ({ type: InquiryActionTypes.CLEAR_EVALUATE });

export const setCurrentPeople = (payload) => ({
  type: InquiryActionTypes.SET_INQUIRY_CURRENTPEOPLE,
  payload,
});

/****** 收到通知结束问诊 ******/
export const pushIMInquiryEndNoticeOrOther = (payload = {}) => ({
  type: InquiryActionTypes.UPDATE_INQUIRY_END_OR_OTHER_HANDLER,
  payload,
});

// 获取第三方医生详情
export const fetchThirdDoctorDetail = (payload?: object) => ({
  type: InquiryActionTypes.THIRD_DOCTOR_DETAIL,
  payload,
});

//获取产品列表
export const fetchProductList = (payload?: object, onSuccess?: any) => ({
  type: InquiryActionTypes.PRODUCT_LIST,
  payload,
  onSuccess,
})

/**
 * 接收到医生开具处方消息
 */
export const receivePrescription = (payload: { inquiryNo: string; status: boolean }) => ({
  type: InquiryActionTypes.RECEIVE_DOCTOR_PRESCRIPTION,
  payload,
});

/**
 * 三甲医生的专业信息
 */
export const fetchThirdDoctorProfession = (payload: any) => ({
  type: InquiryActionTypes.FETCH_THIRD_DOCTOR_PROFESSION,
  payload,
})
